<template>
  <div class="page-container">
    <section class="cols">
      <h2>{{data.title}}</h2>
      <div class="col-content">
        <div class="wysiwyg" v-html="data.content"></div>
        <a v-for="button in data.buttons" :href="button.link.url" :target="button.link.target" class="btn" :key="button.link.url">{{button.link.title}}</a>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: ['data'],
  // data() {
  // },
  mounted() {
  },
  methods: {
  }
};
</script>

<style scoped lang="less">
@import '../css/variables';

.cols {
  display: flex;
  margin: 70px 0;
  @media (max-width: @mobile) {
    display: block;
  }

  h2 {
    min-width: 25%;
    margin: 0 50px 40px 0;
  }
  .col-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .btn {
      margin-bottom: 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Columns.vue